export default __webpack_public_path__ + "static/media/abebe.41bb5945.jpg";